import React from "react"
import types from "prop-types"
import { Select } from "shared/selects"
import { useSelector } from "react-redux"
import { workflowActionShape } from "utils/propTypeShapes"
import { getCategoryStatuses } from "reduxSlices/formBuilderSlice"
import { actionValidations } from "utils/workflowHelpers"
import FormsyValidation from "shared/FormsyValidation"

const DefineStatusData = ({ action, actionIndex, changeActionData }) => {
  const statuses = useSelector(getCategoryStatuses)
  const statusListOptions = statuses.map((status) => ({
    value: status.id,
    label: status.name,
  }))
  const updateStatus = (statusId) => changeActionData(actionIndex)({ statusId })
  const validations = actionValidations(action.type)

  return (
    <span className="relative">
      <Select
        options={statusListOptions}
        value={action.data?.statusId}
        placeholder="Select status"
        style={{ height: "32px" }}
        onChange={updateStatus}
        label="select new submission status when workflow runs"
      />
      <FormsyValidation
        name={`actions[${actionIndex}]`}
        value={action}
        validations={{ validations }}
      />
    </span>
  )
}

DefineStatusData.propTypes = {
  action: workflowActionShape.isRequired,
  changeActionData: types.func.isRequired,
  actionIndex: types.number.isRequired,
}

export default DefineStatusData
